// Specify the element you want to inject as a string
var newElement = '<div class="top-footer"><a class="footer-guarantee" href="/pages/policies"><img src="//cdn.shopify.com/s/files/1/0979/8736/files/MoneyBack_Guarantee_150x.png?v=1634750845" class="top-footer-img"></a></div>';

// Select the .footer div
var footerDiv = document.querySelector('.footer');

// Insert the new element at the beginning of the .footer div
footerDiv.insertAdjacentHTML('afterbegin', newElement);
